const messages = {
  error: [
    'Пожалуйста, попробуйте позже',
    'Во время выполнения запроса что-то пошло не так.',
  ],
};

const alertManager = {
  init() {
    this.popup = document.querySelector('#alert');
    this.title = document.querySelector('#alert-title');
    this.text = document.querySelector('#alert-text');
  },

  show(msg) {
    this.popup.hidden = false;

    // eslint-disable-next-line prefer-destructuring
    this.title.innerHTML = messages[msg][0];
    // eslint-disable-next-line prefer-destructuring
    this.text.innerHTML = messages[msg][1];
  },

  hide() {
    this.popup.hidden = true;
  },

  isVisible() {
    return !this.popup.hidden;
  },
};

export default alertManager;



// WEBPACK FOOTER //
// ../base/js/managers/alert.js